import app from './feathers'
import { mediaStore } from '../stores/mediaStore'

const fileService = app.service('files')

const methods = {
    async get() {
        const media = await fileService.find()
        mediaStore.set(media.data)
        return media
    },
}

export default methods
